module.exports = __webpack_public_path__ + "static/media/eye5.cc87e985.webp";